import { css } from "@emotion/css"

type Props = {
  direction: "top" | "bottom"
}

const Arrow = ({ direction }: Props) => {
  const deg = direction === "top" ? -45 : 135

  return (
    <span
      className={css`
        box-sizing: border-box;
        width: 8px;
        height: 8px;
        border-top: solid 2px #444444;
        border-right: solid 2px #444444;
        transform: rotate(${deg}deg);
      `}
    />
  )
}

export default Arrow
